import { createFileRoute } from "@tanstack/react-router";

import FaqSection from "@/components/marketing/FaqSection";
import HowItWorks from "@/components/marketing/HowItWorks";
import { marketingHead } from "@/components/marketing/marketingHead";
import ProductHero from "@/components/marketing/ProductHero";
import RelatedProducts from "@/components/marketing/RelatedProducts";
import StemsCatalog from "@/components/marketing/stems/StemsCatalog";
import StemsDemo from "@/components/marketing/stems/StemsDemo";
import StemsUses from "@/components/marketing/stems/StemsUses";
import StemsWhy from "@/components/marketing/stems/StemsWhy";
import Footer from "@/components/nav/Footer";

const LEDE =
  "Every track you upload is automatically separated into vocals, instrumentals, drums, bass, and more, ready whenever you need them.";

export const Route = createFileRoute("/stems")({
  component: StemsPage,
  head: () =>
    marketingHead({
      title: "AI Stem Splitter & Vocal Remover | Lutely",
      description: LEDE,
      path: "/stems",
    }),
});

const STEPS = [
  {
    title: "Upload your track",
    body: "Add a new audio file to Lutely.",
  },
  {
    title: "Lutely separates it automatically",
    body: "The track is analyzed and divided into clear, organized stem files.",
  },
  {
    title: "Use the stems when you need them",
    body: "Download the files or add them to a Super Single for fans.",
  },
];

const FAQ = [
  {
    question: "What stems does Lutely provide?",
    answer:
      "Every upload is automatically separated into vocals, instrumental, drums, bass, and additional instrument groups depending on the recording.",
  },
  {
    question: "Can I use Lutely as a vocal remover?",
    answer:
      "Yes. You can isolate the instrumental or download the vocals separately.",
  },
  {
    question: "Do I need the original session files?",
    answer:
      "No. Lutely separates stems from your finished audio file, so you can work with new tracks or back catalog recordings without the original multitrack session.",
  },
  {
    question: "Can fans receive stems?",
    answer:
      "Yes. Artists can include selected assets in a Super Single sold directly to fans.",
  },
];

function StemsPage() {
  return (
    <main className="flex flex-col bg-white">
      <ProductHero
        title={
          <>
            <span className="block font-permanent-marker text-[clamp(68px,7vw,96px)] font-normal normal-case leading-[0.92] tracking-[-0.035em] text-teal-500 max-[680px]:text-[clamp(58px,18vw,76px)]">
              Stems
            </span>
            <span className="mt-4 block max-w-[650px] font-figtree text-[clamp(40px,5vw,64px)] font-black uppercase leading-none tracking-[-0.05em] max-[680px]:mt-3 max-[680px]:text-[clamp(36px,11vw,50px)]">
              For your entire music catalog.
            </span>
          </>
        }
        lede={LEDE}
        cta="Upload a Track"
        proof={["Vocals and instrumentals", "Multiple downloadable stems"]}
        stage={<StemsDemo />}
        plainStage
      />
      <HowItWorks title="How it works" steps={STEPS} kicker={false} />
      <StemsUses />
      <StemsWhy />
      <StemsCatalog />
      <FaqSection items={FAQ} title="FAQ" kicker={false} />
      <RelatedProducts current="stems" />
      <Footer />
    </main>
  );
}
